import React from "react";
import HomePageTabOneApp from "./modules/HomePageTabOneApp";
import {isNullOrUndefined } from "./modules/CommonFunctions";
import ErrorBoundary from './modules/ErrorHandler';
import { Header } from './modules/HeaderContent';
import { Footer } from './modules/FooterContent';
import { SiteCatalyst } from '../components/modules/SiteCatalyst';
/*Home Page - One APP Landing page*/
/*loaded from AEM json url*/
/*bridge calls*/ /*native.js*/
export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.isValidUser = document.cookie.indexOf('userinfo') > -1 ? true : false;
    this.availableDevices = [
      "overview",
      "billing & account",
      "internet",
      "tv",
      "phone"
    ];
    if (
      !isNullOrUndefined(this.props.AvailableDevices) &&      
      this.props.AvailableDevices !== "ALL" &&
      this.props.AvailableDevices.length > 0
    ) {
      this.availableDevices = [];
      this.availableDevices = this.props.AvailableDevices.map(function(x) {
        return x.toLowerCase();
      });
      if(this.availableDevices.indexOf("overview") < 0) {
        this.availableDevices.push("overview");
      }
      if(this.availableDevices.indexOf("billing & account") < 0) {
        this.availableDevices.push("billing & account");
      }
    }
  }

  componentDidMount() {
    
  }

  
  render() {
    document.body.classList.add("home_page");
    let isSignInUser = document.cookie.indexOf("userinfo") > -1 ? true : false;
    if (isSignInUser) {
      return (
        <React.Fragment>
          <ErrorBoundary>
            <Header/>
          </ErrorBoundary>

          <main role="main">
            <ErrorBoundary>
              <HomePageTabOneApp
                AvailableDevices={this.availableDevices}
                TabData={this.props.TabData}
              />
            </ErrorBoundary>
          </main>
          <ErrorBoundary>
            <Footer/>
          </ErrorBoundary>
          <input type="hidden" value="Auth" id="loginType"/>
          <ErrorBoundary>
          <SiteCatalyst PageDetails={this.props.NeedMoreSupportData.pagedetails}/>
          </ErrorBoundary>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
           <ErrorBoundary>
            <Header/>
          </ErrorBoundary>
          <main role="main">
            <ErrorBoundary>
            <HomePageTabOneApp
              AvailableDevices={this.availableDevices}
              TabData={this.props.TabData}
            />
            </ErrorBoundary>
          </main>
          <ErrorBoundary>
            <Footer/>
          </ErrorBoundary>
          <input type="hidden" value="UnAuth" id="loginType"/>
          <ErrorBoundary>
          <SiteCatalyst PageDetails={this.props.NeedMoreSupportData.pagedetails}/>
          </ErrorBoundary> 
        </React.Fragment>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/HomePageOneApp.js